jQuery(document).ready(function ($) {

	//##########################################//
	//###*****   Scroll Functions 
	//##########################################//
	function scrollToOffset(element) {
	    var $element = jQuery(element);
	    var top = $element.offset().top;
	    var manualOffset = 0;
	
	    offset = top < manualOffset ? top : top - manualOffset;

	    $('body,html').animate({ scrollTop: offset },500);
	 
	}
	
	function smoothScrollToElementDiv (el, speed, top) {
		var speed = speed || 800;
		var top = top || 60;
		var elementToScrollToID = $(el)
		$('html, body').animate({
		  scrollTop: $(elementToScrollToID).offset().top - top
		}, speed)
	}
	
	
	function smoothScrollToElement (el, speed, top) {
		var speed = speed || 800;
		var top = top || 60;
		var elementToScrollToID = $(el).attr('href')
		$('html, body').animate({
		  scrollTop: $(elementToScrollToID).offset().top - top
		}, speed)
	}

});